import actions, { types as ats } from ".";

const {
	[ats.DO_LOGOUT]: handleLogoutAction,
	[ats.RETRIEVE_ASSETS]: handleSearchAction,
	[ats.CLEAR_SEARCH_TERM]: handleClearSearchTermAction,
	[ats.TOGGLE_FILTERS_PANEL]: handleTogglePanelAction,
	[ats.CLEAR_FILTER_PARAMS]: handleClearSearchParamsAction,
	[ats.SELECT_ASSETS]: handleSelectAssetsAction,
	[ats.RETRIEVE_PRODUCTS]: retrieveProductAction,
	[ats.RETRIEVE_HOME_PAGE_ASSETS]: retrieveHomePageAssetsAction,
	[ats.SELECT_PRODUCT]: handleSelectProductAction,
	[ats.SELECT_ASSETS_FORMAT]: handleSelectAssetFormatAction,
	[ats.PURCHASE]: handlePurchaseAssetAction,
	[ats.DO_LOGIN]: handleLoginAction,
} = actions.creators;


export default {
	handleLogoutAction,
	handleSearchAction,
	handleClearSearchTermAction,
	handleTogglePanelAction,
	handleClearSearchParamsAction,
	handleSelectAssetsAction,
	retrieveProductAction,
	retrieveHomePageAssetsAction,
	handleSelectProductAction,
	handleSelectAssetFormatAction,
	handlePurchaseAssetAction,
	handleLoginAction,
};
